<template>
  <div class="chat-container">
    <div class="chat-box">
      <div class="chat-box-header">
        Facebook Messenger Chat
      </div>
      <div class="chat-box-body">
        <div class="chat-box-overlay"></div>
        <div class="chat-logs">
          <p
            v-if="senderId && conversationMsgs.length"
            v-for="(msg, idx) in conversationMsgs"
            :key="idx"
          >
            {{ msg.from }}: {{ msg.text }}
          </p>
        </div>
      </div>
      <div class="chat-input">
        <form @submit.prevent="sendMsg">
          <input
            ref="chatInput"
            v-model="textToSend"
            id="chat-input"
            autocomplete="off"
            placeholder="Send a message..."
          />
          <button type="submit" class="chat-submit" id="chat-submit">
            <i class="fas fa-share"></i>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SocketEndpoints from "../../../mixins/system/SocketEndpoints";

export default {
  name: "FacebookMessengerChat.container",
  data() {
    return {
      textToSend: "",
      textFromAgent: [],
      userFbId: null,
      textFromFb: [],
      senderId: null,
      conversationMsgs: []
    };
  },
  mixins: [SocketEndpoints],
  methods: {
    sendMsg() {
      if (!this.textToSend || !this.senderId) return;
      this.chatSocket.emit("send_chat_text", {
        txt: this.textToSend,
        from: this.auth.user.id
      });
      this.conversationMsgs.push({ from: "Agent ", text: this.textToSend });
      this.textToSend = "";
    },
    showMsgFromFb(data) {
      this.senderId = data.senderId;
      this.conversationMsgs.push({ from: "Facebook User", text: data.text });
    },
    getSenderStyle(sender) {
      if (sender === "Agent") {
        return "msg_agent";
      }
      return "msg_fb";
    }
  },
  created() {
    this.chatSocket.on("receive_chat_text", this.showMsgFromFb);
  },
  components: {},
  watch: {
    conversationMsgs: function() {
   //   console.log(this.conversationMsgs);
      // $(".chat-logs").scrollTop($(".chat-logs").height());
      $(".chat-logs").animate(
        { scrollTop: $(".chat-logs")[0].scrollHeight },
        1000
      );
    }
  }
};
</script>

<style scoped>
.chat-container {
  font-family: Montserrat, serif;
  width: 98%;
  height: 100%;
}
.chat-box {
  /*background: yellow;*/
  background: #efefef;
  width: 100%;
  height: 100%;
  /*   box-shadow: 0px 5px 35px 9px #464a92; */
}
.chat-box-toggle {
  float: right;
  margin-right: 15px;
  cursor: pointer;
}
.chat-box-header {
  background: #5a5eb9;
  height: 23px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: white;
  text-align: center;
  font-size: 12px;
  padding-top: 5px;
}
.chat-box-body {
  position: relative;
  height: 150px;
  border: 1px solid #ccc;
}
.chat-box-body:after {
  content: "";
  background-image: url("data:image/svg+xml;base64,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");
  opacity: 0.1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  position: absolute;
  z-index: -1;
}

#chat-input {
  background: #f4f7f9;
  width: 98%;
  /*border: none;*/
  resize: none;
  position: absolute;
  bottom: 0px;
  outline: none;
  border: 1px solid #ccc;
  padding-right: 50px;
  padding-left: 15px;
  color: #888;
  border-top: none;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  overflow: hidden;
}
.chat-input > form {
  margin-bottom: 0;
}
#chat-input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #ccc;
}
#chat-input::-moz-placeholder {
  /* Firefox 19+ */
  color: #ccc;
}
#chat-input:-ms-input-placeholder {
  /* IE 10+ */
  color: #ccc;
}
#chat-input:-moz-placeholder {
  /* Firefox 18- */
  color: #ccc;
}
.chat-submit {
  position: absolute;
  right: 35px;
  background: transparent;
  box-shadow: none;
  border: none;
  border-radius: 50%;
  color: #5a5eb9;
  width: 25px;
  height: 25px;
}
.chat-logs {
  padding: 15px;
  max-height: 90px;
  overflow-y: scroll;
}

.chat-logs::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.chat-logs::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

.chat-logs::-webkit-scrollbar-thumb {
  background-color: #5a5eb9;
}

.msg_fb {
  color: blue;
}
.msg_agent {
  color: black;
}

@media only screen and (max-width: 500px) {
  .chat-logs {
    height: 40vh;
  }
}

.chat-msg.user > .msg-avatar img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  float: left;
  width: 15%;
}
.chat-msg.self > .msg-avatar img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  float: right;
  width: 15%;
}
.cm-msg-text {
  background: white;
  padding: 10px 15px 10px 15px;
  color: #666;
  max-width: 75%;
  float: left;
  margin-left: 10px;
  position: relative;
  margin-bottom: 20px;
  border-radius: 30px;
}
.chat-msg {
  clear: both;
}
.chat-msg.self > .cm-msg-text {
  float: right;
  margin-right: 10px;
  background: #5a5eb9;
  color: white;
}
.cm-msg-button > ul > li {
  list-style: none;
  float: left;
  width: 50%;
}
.cm-msg-button {
  clear: both;
  margin-bottom: 70px;
}
</style>
